import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, Route, UrlSegment } from '@angular/router';
import {AuthenticationService} from '../_services';
import jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import { tap, map, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';


@Injectable({providedIn: 'root'})
export class AuthGuard  {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean| Observable<boolean> {
    return this.checkLoggedIn().pipe(
      tap(data => {
        if (data === false) {
          // No loggeado, redirige a la página de login con returnUrl.
          this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
        }
      })
    );
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean| Observable<boolean> {
    return this.checkLoggedIn();
  }

  checkLoggedIn() {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      // Loggeado así que retorna true;
      if (moment().isBefore(moment(+jwt_decode(currentUser.token)['exp'] * 1000))) {
        return of(true);
      } else {
        return this.authenticationService.refreshToken().pipe(
          map(res => {
            if (res['token']) {
              const refresh = jwt_decode(res['token'])['refreshToken'];
              this.authenticationService.setActiveToken(res['token'], refresh, '');
              return true;
            }
          }),
          catchError(err => {
            this.authenticationService.clearSession();
            return of(false);
          })
        );
      }
    } else {
      return of(false);
    }
  }
}
